import useIsHijacked from './useIsHijacked';
import useUser from './useUser';

function useShowSuperuserUI() {
  const user = useUser();
  const showSuperuserUI = useIsHijacked() || user.showAdminUI;

  return showSuperuserUI;
}

export default useShowSuperuserUI;
